export const LAYOUT_CONSTANTS = {
  APP_BAR_HEIGHT: 64,
  DRAWER_WIDTH: 240,
};

export const SIDE_MENU_WIDTH = {
  XS: '56px',
  SM: '72px',
};
